<nav class="step-nav">
  @for (step of steps; track step.path; let i = $index) {
    @if (step.enabled && !isLocked(step)) {
      <a
        class="step-nav__item"
        [routerLink]="step.path"
        routerLinkActive="step-nav__item--active"
      >
        <span class="step-nav__index">{{ i + 1 }}</span>
        <mat-icon class="step-nav__icon">{{ step.icon }}</mat-icon>
        <span class="step-nav__label">{{ step.label }}</span>
      </a>
    } @else {
      <span
        class="step-nav__item step-nav__item--disabled"
        [title]="isLocked(step) ? 'Upload both files first' : 'Coming soon'"
      >
        <span class="step-nav__index">{{ i + 1 }}</span>
        <mat-icon class="step-nav__icon">{{ step.icon }}</mat-icon>
        <span class="step-nav__label">{{ step.label }}</span>
      </span>
    }
    @if (i < steps.length - 1) {
      <span class="step-nav__divider"></span>
    }
  }
</nav>
